<template>
  <div class="ui segment" :class="{ loading: isLoading }">
    <div class="ui center aligned very relaxed grid">
      <div class="column">
        <h2 class="ui teal image header">
          <img class="image" :src="logo" />
          <div class="content">
            Ingresar a tu cuenta
          </div>
        </h2>
        <div v-if="message" class="ui  warning message">
          <div class="header">
            Error iniciando sesión
          </div>
          <p>{{ message }}</p>
        </div>
        <div class="ui large form">
          <div class="ui center aligned stacked segment">
            <div class="field" :class="{ error: $v.email.$error }">
              <div class="ui left icon input">
                <i class="phone icon"></i>
                <input
                  type="text"
                  name="email"
                  placeholder="Celular o correo"
                  autocomplete="nope"
                  v-model.trim="$v.email.$model"
                />
              </div>
            </div>
            <div class="field" :class="{ error: $v.password.$error }">
              <div class="ui left icon input">
                <i class="lock icon"></i>
                <input
                  type="password"
                  name="password"
                  placeholder="Contraseña"
                  autocomplete="new-password"
                  v-model.trim="$v.password.$model"
                  @keyup.enter="login()"
                />
              </div>
            </div>
            <div
              class="ui fluid teal large  submit button"
              @click="login"
              :class="{ disabled: $v.$invalid }"
            >
              Iniciar sesión
            </div>
          </div>
        </div>
        <br />
        <div class="ui message" v-if="showRegisterButton">
          <h4>¿No tienes cuenta?</h4>
          <div class="ui blue fluid button" @click="signup">
            Regístrate
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'LoginForm',
  props: ['message', 'isLoading', 'showRegisterButton'],
  data: function() {
    return {
      email: '',
      password: ''
    };
  },
  computed: {
    logo: function() {
      return this.$store.getters['application/getLogo'];
    }
  },
  validations: {
    email: {
      required
    },
    password: {
      required
    }
  },
  methods: {
    login: function() {
      if (this.email.trim() === '' || this.password.trim() === '') {
        console.log('Feel empty fields');
      } else {
        this.$emit('onLogin', {
          username: this.email.toLowerCase(),
          password: this.password
        });
      }
    },
    signup: function() {
      this.$emit('onRegister');
    }
  }
};
</script>

<style scoped="true" lang="css">
.column {
  max-width: 450px;
}
</style>
